module.exports = __webpack_public_path__ + "static/media/view.b44ea8a0.svg";